/*eslint-disable */
import LayerService from '@/services/layers/LayerService';

import store from '@/store/index';
import {
  LayerGroup, LeafletEvent, Marker, DivIcon, Polyline,
  markerClusterGroup,
} from 'leaflet';
import { IFeatureCollection } from '@/interfaces/IFeatureCollection';
import AssetIconService from '@/services/AssetIconService';
import IPosition from '@/interfaces/IPosition';
import IFeature from '@/interfaces/IFeature';
import RedrawService from '@/services/RedrawService';
import MapService from '../MapService';
import { toRaw } from 'vue';

export default class TrackEndPointsLayerService extends LayerService {
  // eslint-disable-next-line global-require
public layerLineGroup: LayerGroup | null = null;

  onClick = (e: LeafletEvent, metaData: any, leafletMarker: Marker<any>): void => {
    Promise.all([
      store.dispatch('updateTrackLines', metaData.linestring),
    ])
    .then(() => {
      const redrawService: RedrawService = new RedrawService(new MapService(store.state.leafletMapInstance));
      redrawService.redrawOnlyTrackLines();
    });
  };

  redrawLayer = (): LayerGroup<any> => {
    const points: IFeatureCollection = store.state.trackEndPoints;
    // points.features = points.features.map((item: any) => {
    //   // data transformation
    //   return {
    //     ...item,
    //     properties: {
    //       ...item.properties,
    //       linestring: item.geometry.coordinates,
    //     },
    //     geometry: {
    //       coordinates: item.geometry.coordinates.slice(-1)[0],
    //     },
    //   };
    // });

    return this.generateMarkerClusterLayer(points);
  };

  protected generateMarkerClusterLayer = (positions: IFeatureCollection): LayerGroup => {
    const markerClusterGroupInstance = markerClusterGroup({
      showCoverageOnHover: false,
      maxClusterRadius: 40,
      iconCreateFunction: (cluster) => {
        const population = cluster.getChildCount();
        return new DivIcon({
          html: this.generateClusterHtml(population),
          className: 'custom-cluster-icon',
          iconSize: [this.clusterWidth, this.clusterHeight],
          iconAnchor: [this.clusterWidth / 2, this.clusterHeight / 2],
        });
      },
    });

    positions.features.forEach((feature: any) => {
      if (!feature.geometry) return;

      const { coordinates } = feature.geometry;
      const [lng, lat] = coordinates as Array<number>;

      const singleMarker = this.createMarker({ lat, lng }, feature);
      markerClusterGroupInstance.addLayer(toRaw(singleMarker));
    });

    return markerClusterGroupInstance;
  };

  generateClusterHtml(population: number) {
    const iconUrl = AssetIconService.getSvgMapIcon('cluster_way_end');
    const template: string = `
      <div
        class="map-cluster-custom-icon"
        style='background-image: url("${iconUrl}")'
      >
        <span class="cluster-counter">${population}</span>
      </div>
        `;

      return template;
  };

  protected generateHtmlPointTemplate = (metaData: any): string => {
    const iconUrl = AssetIconService.getSvgMapIcon('marker_way_end');
    const template: string = `
        <div
            class="map-simple-icon map-simple-icon--parking-meter"
            style='background-image: url("${iconUrl}")'
        >
        </div>
      `;

    return template;
  }
}
